<template>
  <a
    href="#"
    class="btn btn-cta"
    :class="{ 'btn-cta-group' : myLot.groupWinner }"
    @click.prevent="(e) => emit('click', e)"
  >
    <span v-if="lot.lastBidUuid">
      {{ $t("common.relaunch") }}
      <span
        v-if="myLot.groupWinner"
        class="text-xs"
      >{{ $t("common.relaunch_same_group") }}</span>
    </span>
    <span v-else>{{ $t("common.offer") }}</span>
  </a>
</template>

<script setup>
const props = defineProps({
    auction: {
      type: Object,
      required: true
    },
    lot: {
        type: Object,
        required: true
    },
    myLot: {
        type: Object,
        required: true
    }
})

const emit = defineEmits(['click'])
</script>